import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Layout as AntLayout } from "antd";

const { Content } = AntLayout;

function Layout({ children }) {
  return (
    <AntLayout>
      <Header />
      <Content>{children}</Content>
      <Footer />
    </AntLayout>
  );
}

export default Layout;